module.exports = __webpack_public_path__ + "assets/img/titleBg.85113d48.png";